import { XMarkIcon } from "@heroicons/react/24/outline";
import { useRef } from "react";
import { useClickOutsideBlock } from "../helpers/useClickOutside";
import { LoaderSpinner } from "./LoaderSpinner";

export const ConfrimModal = ({
    isOpen,
    isLoading,
    containerClassName,
    cancelClick,
    size,
    submitClick,
    title,
    description,
    cancelButtonTitle = "Cancel",
    confirmButtonTitle,
    testId,
    children
}) => {
    const modalRef = useRef(null);
    useClickOutsideBlock(modalRef, cancelClick);
    if (!isOpen) return null;
    return (
        <div aria-hidden="true" className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-[60] justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full" data-testid={testId}>
            <div className="bg-gray-700 top-0 right-0 left-0 fixed z-[60] justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full opacity-30" />
            <div ref={modalRef} className={`relative p-5 w-full ${size ? size : "max-w-2xl"} max-h-full bg-white border top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[70] rounded-md ${containerClassName || ""}`}>
                <div className="flex justify-end">
                    <button 
                        onClick={cancelClick}
                        data-testid={testId ? `xmark-button-${testId}` : undefined}
                        className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-primary hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                    </button>
                </div>
                <h4 className="text-xl py-5">{title}</h4>
                {description && <p className="pb-5 text-sm text-gray-600">{description}</p>}
                {children}
                <div className="flex justify-end gap-2">
                    <button 
                        onClick={() => {
                            cancelClick()
                        }}
                        data-testid={testId ? `cancel-button-${testId}` : undefined}
                        className="min-w-20 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:w-auto sm:text-sm"
                    >
                        {isLoading ? <LoaderSpinner width="20" height="20" border="3" colorSpinner="gray"/> : cancelButtonTitle}
                    </button>
                    <button 
                        onClick={() => {
                            if (!isLoading) {
                                submitClick()
                            }
                        }}
                        data-testid={testId ? `submit-button-${testId}` : undefined}
                        className="min-w-24 justify-center inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                        {isLoading ? <LoaderSpinner width="20" height="20" border="3" colorSpinner="gray"/> : confirmButtonTitle}
                    </button>
                </div>
            </div>
        </div>
    )
}